import type Quill from 'quill/core';
import type HeaderCollapse from '../HeaderCollapse';

function getHeaderCollapse(quill: Quill): HeaderCollapse | undefined {
  return quill.getModule('headerCollapse') as HeaderCollapse | undefined;
}

export default getHeaderCollapse;
